module.exports = __webpack_public_path__ + "img/taylor_ryan.jpeg";